<div class="modal-dialog m-0 p-4 document">
    <div class="modal-header p-0 justify-content-between align-items-center border-0 close--icon">
        <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-32 border p-1 cursor rounded-circle"
            (click)="onClose()">
    </div>
    <div class="text-center">
        <img src="assets/images/icons/greenTick.svg" alt="">
    </div>
    <div class="fs-16 fw-500 modal-body p-0 mt-1 mb-2 text-center">
        Quickbooks integrated successfully
    </div>
</div>